// src/App.jsx
import { useState, lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PrivateRoute from "./common/PrivateRoute";
import PublicRoute from "./common/PublicRoute";
import WaitDialog from "./components/WaitDialog";
import Layout from "./components/Layout.jsx";
// import FileRetrieve from "./pages/FileRetrieve.jsx";

const Register = lazy(() => import("./pages/Register"));
// const Login = lazy(() => import("./pages/Login"));
const LoginNew = lazy(() => import("./pages/LoginNew"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Index = lazy(() => import("./pages/Index"));
const SendDataPage = lazy(() => import("./pages/SendData"));
const ProductsPageNew = lazy(() => import("./pages/ProductsNew"));
const NetworkManagement = lazy(() => import("./pages/NetworkManagement"));
const ManageProductFields = lazy(() => import("./pages/ManageProductFields"));
const ProductDocuments = lazy(() => import("./pages/ProductDocuments"));
const ManageProductDataTransactions = lazy(
  () => import("./pages/ManageProductDataTransactions.jsx"),
);
const TransactionManage = lazy(() => import("./pages/TransactionManage.jsx"));
const DIDKeyManager = lazy(() => import("./pages/DIDKeyManager"));
const FileRetrieve = lazy(() => import("./pages/FileRetrieve"));
const Help = lazy(() => import("./pages/Help"));

const Navbar = lazy(() => import("./components/Navbar"));
const Sidebar = lazy(() => import("./components/Sidebar"));
const SettingsApiKeyOrgDid = lazy(() => import("./pages/SettingsApiKeyOrgDid"));

// const Network = lazy(() => import("./pages/Network"));
// const ReceivedPackages = lazy(() => import("./pages/ReceivedPackages"));
// const Help = lazy(() => import("./pages/Help"));

const HIDDEN_SIDEBAR_PATHS = ["/onboarding", "/fileRetrieve"];

const AppContent = ({ t }) => {
  const [loading] = useState(false);
  const loggedIn = useSelector((state) => Boolean(state.auth.user?.token));
  const location = useLocation();

  const hideSidebar = HIDDEN_SIDEBAR_PATHS.some((p) =>
    location.pathname.startsWith(p),
  );
  const showSidebar = loggedIn && !hideSidebar;

  return (
    <>
      <Suspense fallback={null}>
        <Navbar />
      </Suspense>

      <Suspense fallback={null}>{showSidebar ? <Sidebar /> : null}</Suspense>

      <div className={`ct-main ${showSidebar ? "ct-main--with-sidebar" : ""}`}>
        <Suspense fallback={<div />}>
          <Routes>
            <Route
              path="/home"
              element={<PrivateRoute component={ProductsPageNew} />}
            />
            <Route
              path="/send"
              element={<PrivateRoute component={SendDataPage} />}
            />
            <Route
              path="/entities"
              element={<PrivateRoute component={ProductsPageNew} />}
            />

            <Route
              path="/transaction"
              element={<PrivateRoute component={TransactionManage} />}
            />

            <Route
              path="/manageEntityFields"
              element={<PrivateRoute component={ManageProductFields} />}
            />
            <Route
              path="/entityDocuments"
              element={<PrivateRoute component={ProductDocuments} />}
            />
            <Route
              path="/manageEntityDataTransactions"
              element={
                <PrivateRoute component={ManageProductDataTransactions} />
              }
            />

            <Route
              path="/networkManagement"
              element={<PrivateRoute component={NetworkManagement} />}
            />

            <Route
              path="/settings"
              element={<PrivateRoute component={SettingsApiKeyOrgDid} />}
            />

            <Route path="/help" element={<PrivateRoute component={Help} />} />

            {/* <Route
              path="/network"
              element={<PrivateRoute component={Network} />}
            />
            <Route
              path="/receivedPackages"
              element={<PrivateRoute component={ReceivedPackages} />}
            />
            <Route path="/help" element={<PrivateRoute component={Help} />} /> */}

            <Route
              path="/"
              element={<PublicRoute restricted component={LoginNew} />}
            />
            <Route
              path="/login"
              element={<PublicRoute restricted component={LoginNew} />}
            />

            {/* Public pages (no sidebar, wrapped in Layout) */}
            <Route
              path="/*"
              element={
                <Layout>
                  <Routes>
                    {/* <Route
                      path="/"
                      element={<PublicRoute restricted component={Index} />}
                    /> */}

                    <Route
                      path="/register"
                      element={<PublicRoute restricted component={Register} />}
                    />

                    {/* <Route
                      path="/login"
                      element={<PublicRoute restricted component={Login} />}
                    /> */}

                    <Route
                      path="/forgotPassword"
                      element={
                        <PublicRoute restricted component={ForgotPassword} />
                      }
                    />

                    {/* DID Key Manager - accessible regardless of login state */}
                    <Route path="/onboarding" element={<DIDKeyManager />} />

                    <Route path="/fileRetrieve" element={<FileRetrieve />} />

                    <Route
                      path="*"
                      element={
                        <Navigate to={loggedIn ? "/home" : "/"} replace />
                      }
                    />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </Suspense>
      </div>

      <WaitDialog loading={loading} lang={t} />
    </>
  );
};

const App = ({ t }) => {
  return (
    <Router>
      <AppContent t={t} />
    </Router>
  );
};

export default withTranslation()(App);
